/* ═══════════════════════════════════════════
   ORYN SHOPIFY THEME — oryn.js
═══════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── LOADER ── */
  function initLoader() {
    const loader = document.getElementById('loader');
    if (!loader) return;
    const bar = loader.querySelector('.ld-bar');
    const num = loader.querySelector('.ld-num');
    let pct = 0;
    const tick = setInterval(() => {
      pct = Math.min(100, pct + Math.floor(Math.random() * 7) + 4);
      if (bar) bar.style.width = pct + '%';
      if (num) num.textContent = String(pct).padStart(3, '0');
      if (pct >= 100) {
        clearInterval(tick);
        setTimeout(() => {
          loader.classList.add('out');
          loader.addEventListener('animationend', () => {
            loader.style.display = 'none';
            const hero = document.querySelector('.hero__body');
            if (hero) hero.closest('.hero')?.classList.add('hero-loaded');
          }, { once: true });
        }, 380);
      }
    }, 55);
  }

  /* ── CURSOR ── */
  function initCursor() {
    const cur  = document.getElementById('cur');
    if (!cur || window.matchMedia('(pointer: coarse)').matches) {
      if (cur) cur.style.display = 'none';
      document.body.style.cursor = 'auto';
      return;
    }
    const dot  = cur.querySelector('.c-dot');
    const ring = cur.querySelector('.c-ring');
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top  = my + 'px';
    });
    (function tick() {
      rx += (mx - rx) * 0.09;
      ry += (my - ry) * 0.09;
      ring.style.left = Math.round(rx * 10) / 10 + 'px';
      ring.style.top  = Math.round(ry * 10) / 10 + 'px';
      requestAnimationFrame(tick);
    })();
    document.querySelectorAll('a, button, [role="button"]').forEach(el => {
      el.addEventListener('mouseenter', () => cur.classList.add('cur-big'));
      el.addEventListener('mouseleave', () => cur.classList.remove('cur-big'));
    });
    document.addEventListener('mouseleave', () => cur.classList.add('cur-hide'));
    document.addEventListener('mouseenter', () => cur.classList.remove('cur-hide'));
  }

  /* ── STICKY NAV ── */
  function initNav() {
    const header = document.getElementById('site-header');
    if (!header) return;
    const onScroll = () => header.classList.toggle('stuck', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Mobile menu toggle */
    const toggle = document.getElementById('nav-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    if (toggle && mobileMenu) {
      toggle.addEventListener('click', () => {
        const isOpen = toggle.classList.toggle('open');
        mobileMenu.classList.toggle('open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
        document.body.style.overflow = isOpen ? 'hidden' : '';
      });
      mobileMenu.querySelectorAll('a').forEach(a => {
        a.addEventListener('click', () => {
          toggle.classList.remove('open');
          mobileMenu.classList.remove('open');
          document.body.style.overflow = '';
        });
      });
    }
  }

  /* ── SCROLL REVEAL ── */
  function initReveal() {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('vi');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -55px 0px' });
    document.querySelectorAll('.rv, .rl, .rr, .rs').forEach(el => obs.observe(el));
  }

  /* ── PARALLAX ── */
  function initParallax() {
    const plxEls = [...document.querySelectorAll('[data-parallax-speed]')];
    const heroVid = document.querySelector('.hero__video-wrap video');

    function run() {
      const sy = window.scrollY;
      const vh = window.innerHeight;

      /* Background image parallax */
      plxEls.forEach(el => {
        const speed  = parseFloat(el.dataset.parallaxSpeed || '-0.14');
        const parent = el.parentElement;
        const rect   = parent.getBoundingClientRect();
        const mid    = rect.top + rect.height / 2 - vh / 2;
        el.style.transform = `translateY(${(mid * speed).toFixed(2)}px) scale(1.1)`;
      });

      /* Hero video drift */
      if (heroVid && sy < vh) {
        heroVid.style.transform = `scale(1.12) translateY(${(sy * 0.16).toFixed(2)}px)`;
      }

      /* Tech panel images */
      document.querySelectorAll('.tp-img').forEach(img => {
        const rect = img.getBoundingClientRect();
        const mid  = rect.top + rect.height / 2 - vh / 2;
        img.style.transform = `translateY(${(mid * -0.08).toFixed(2)}px) scale(1.1)`;
      });
    }

    window.addEventListener('scroll', run, { passive: true });
    run();
  }

  /* ── HERO MOUSE PARALLAX ── */
  function initHeroMouseParallax() {
    const hero = document.querySelector('.hero');
    const body = document.querySelector('.hero__body');
    if (!hero || !body) return;
    hero.addEventListener('mousemove', e => {
      const cx = (e.clientX / hero.offsetWidth  - 0.5) * 18;
      const cy = (e.clientY / hero.offsetHeight - 0.5) * 10;
      body.style.transform  = `translate(${cx}px, ${cy}px)`;
      body.style.transition = 'transform .15s ease';
    });
    hero.addEventListener('mouseleave', () => {
      body.style.transform  = 'translate(0,0)';
      body.style.transition = 'transform .8s ease';
    });
  }

  /* ── COUNTER ANIMATION ── */
  function initCounters() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el     = e.target;
        const target = parseInt(el.dataset.count);
        const suf    = el.dataset.suffix || '';
        let start;
        const step = ts => {
          if (!start) start = ts;
          const p = Math.min((ts - start) / 1500, 1);
          el.textContent = Math.floor((1 - Math.pow(1 - p, 3)) * target) + suf;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = target + suf;
        };
        requestAnimationFrame(step);
        obs.unobserve(el);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-count]').forEach(el => obs.observe(el));
  }

  /* ── CARD TILT ── */
  function initTilt() {
    document.querySelectorAll('.pc, .ec, .sc, .col-card').forEach(card => {
      card.addEventListener('mousemove', e => {
        const { left, top, width, height } = card.getBoundingClientRect();
        const x = (e.clientX - left) / width  - 0.5;
        const y = (e.clientY - top)  / height - 0.5;
        card.style.transform  = `perspective(1000px) rotateY(${x*5}deg) rotateX(${-y*5}deg) translateZ(8px)`;
        card.style.transition = 'transform .05s';
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform  = 'perspective(1000px) rotateY(0) rotateX(0) translateZ(0)';
        card.style.transition = 'transform .7s cubic-bezier(.23,1,.32,1)';
      });
    });
  }

  /* ── SMOOTH ANCHOR SCROLL ── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => {
        const target = document.querySelector(a.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── PRODUCT PAGE ── */
  function initProductPage() {
    /* Variant selector */
    const variantBtns = document.querySelectorAll('.variant-btn');
    const variantInput = document.querySelector('input[name="id"]');
    const priceEl = document.querySelector('.product-page__price');
    const atcBtn  = document.querySelector('.product-page__atc');

    variantBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('unavailable')) return;
        variantBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (variantInput) variantInput.value = btn.dataset.variantId;
        if (priceEl && btn.dataset.price) {
          priceEl.innerHTML = btn.dataset.comparePrice
            ? `<s>${btn.dataset.comparePrice}</s> ${btn.dataset.price}`
            : btn.dataset.price;
        }
        if (atcBtn) atcBtn.disabled = btn.dataset.available === 'false';
      });
    });

    /* Gallery thumbnails */
    const mainImg  = document.querySelector('.product-page__main-img');
    const thumbs   = document.querySelectorAll('.product-page__thumb');
    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        thumbs.forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        if (mainImg && t.dataset.src) {
          mainImg.src = t.dataset.src;
          mainImg.style.animation = 'none';
          mainImg.offsetHeight; /* reflow */
          mainImg.style.animation = 'fadeImg .4s ease';
        }
      });
    });

    /* Add to cart */
    const atcForm = document.querySelector('form[action*="/cart/add"]');
    if (atcForm) {
      atcForm.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = atcForm.querySelector('[type="submit"]');
        const originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        try {
          const formData = new FormData(atcForm);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!res.ok) throw new Error('Failed');
          await res.json();
          btn.textContent = '✓ Added';
          updateCartCount();
          showCartNotification();
        } catch (err) {
          btn.textContent = 'Error — Try again';
        } finally {
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        }
      });
    }
  }

  /* ── CART COUNT UPDATE ── */
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const counts = document.querySelectorAll('.cart-count');
      counts.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    } catch {}
  }

  /* ── CART NOTIFICATION ── */
  function showCartNotification() {
    const n = document.getElementById('cart-notification');
    if (!n) return;
    n.removeAttribute('hidden');
    clearTimeout(n._timer);
    n._timer = setTimeout(() => n.setAttribute('hidden', ''), 4000);
  }

  /* ── QUICK ADD (collection / showcase) ── */
  function initQuickAdd() {
    document.querySelectorAll('.pc-atc').forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        const orig = btn.textContent;
        btn.textContent = 'Adding...'; btn.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          btn.textContent = '✓ Added';
          updateCartCount();
          showCartNotification();
        } catch {
          btn.textContent = 'Error';
        } finally {
          setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
        }
      });
    });
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', () => {
    initLoader();
    initCursor();
    initNav();
    initReveal();
    initParallax();
    initHeroMouseParallax();
    initCounters();
    initTilt();
    initSmoothScroll();
    initProductPage();
    initQuickAdd();
    updateCartCount();
  });

  /* ── SHOPIFY SECTION EVENTS (theme editor live preview) ── */
  document.addEventListener('shopify:section:load', () => {
    initReveal(); initTilt(); initQuickAdd();
  });

})();

/* Fade image keyframe */
const s = document.createElement('style');
s.textContent = '@keyframes fadeImg{from{opacity:0}to{opacity:1}}';
document.head.appendChild(s);
